import { create } from 'zustand';

interface DeleteChecklistStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useDeleteChecklistModal = create<DeleteChecklistStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useDeleteChecklistModal;
